import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import img from "../../../Assets/Home/girl.png";

const Seller = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLanguage = i18n.language || "en";

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true });
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/categories/get-all-categories`)
      .then((response) => {
        const sorted = (response.data || []).sort((a, b) => {
          const seqA = a.sequence || a.sequenceNum || 0;
          const seqB = b.sequence || b.sequenceNum || 0;
          return seqA - seqB;
        });
        setCategories(sorted);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const getLocalizedName = (category) => {
    if (!category?.name) return "";
    if (typeof category.name === "string") return category.name;
    if (typeof category.name === "object") {
      return (
        category.name[currentLanguage] ||
        category.name.en ||
        category.name.hi ||
        "Category"
      );
    }
    return "Category";
  };

  return (
    <div className="bg-white px-4 md:px-10">
      <div
        className="w-full mx-auto flex flex-col lg:flex-row items-center justify-between gap-10 rounded-md px-4 bg-[#FBFBFB]"
        data-aos="fade-up"
      >
        {/* Left Section — Text + Categories + Button */}
        <div
          className="flex-1 text-center lg:text-left space-y-6 p-4"
          data-aos="fade-right"
          data-aos-delay="200"
        >
          <div>
            <h1 className="font-philosopher text-3xl md:text-4xl text-gray-900 mb-3">
              {t("become_seller_title") ||
                "Become a Seller with Bharat Karigari"}
            </h1>
            <p className="text-gray-700 text-lg md:text-xl mx-auto lg:mx-0 font-poppins">
              {t("become_seller_subtitle") ||
                "Join our artisan community and grow your handmade business online."}
            </p>
          </div>

          {/* Dynamic Categories — single scrollable row */}
          <div
            className="flex flex-row flex-nowrap overflow-x-auto gap-4 pb-2 scrollbar-hide"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            {loading
              ? [...Array(7)].map((_, i) => (
                  <div
                    key={i}
                    className="flex flex-col items-center flex-shrink-0"
                  >
                    <div className="w-16 h-16 rounded-full bg-gray-200 animate-pulse mb-2" />
                    <div className="w-14 h-3 bg-gray-100 rounded animate-pulse" />
                  </div>
                ))
              : categories.map((item, index) => {
                  const categoryName = getLocalizedName(item);
                  return (
                    <div
                      key={item._id}
                      className="flex flex-col items-center text-center cursor-pointer hover:scale-105 transition-transform duration-300 flex-shrink-0"
                      data-aos="fade-up"
                      data-aos-delay={index * 80}
                      onClick={() => navigate(`/category/${item._id}`)}
                    >
                      {/* Circular image */}
                      <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-gray-200 bg-gray-100 flex items-center justify-center">
                        {item.imgUrl ? (
                          <img
                            src={item.imgUrl}
                            alt={categoryName}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/64x64.png?text=?";
                            }}
                          />
                        ) : (
                          <svg
                            className="w-10 h-10 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M4 6h16M4 12h16M4 18h16"
                            />
                          </svg>
                        )}
                      </div>

                      {/* Category name below circle */}
                      <h4 className="mt-2 text-xs font-semibold text-gray-800 w-16 line-clamp-2 leading-tight">
                        {categoryName}
                      </h4>
                    </div>
                  );
                })}
          </div>

          {/* Button */}
          <div data-aos="fade-up" data-aos-delay="600">
            <button
              onClick={() => navigate("/seller-registration")}
              className="bg-[#111111] text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-gray-900 transition"
            >
              {t("explore_now") || "Explore Now"}
            </button>
          </div>
        </div>

        {/* Right Section — Girl Image */}
        <div
          className="flex-1 flex justify-center lg:justify-end"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <img
            src={img}
            alt={t("seller_image_alt") || "Seller"}
            className="object-contain drop-shadow-lg max-h-[420px]"
          />
        </div>
      </div>
    </div>
  );
};

export default Seller;







// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

// import logo from "../../../Assets/Home/logo1s.png";
// import logo1 from "../../../Assets/Home/logos.png";
// import logo2 from "../../../Assets/Home/logo2s.png";
// import logo3 from "../../../Assets/Home/logo3s.png";
// import logo5 from "../../../Assets/Home/logo4s.png";
// import logo4 from "../../../Assets/Home/oxlogo.png";
// import img from "../../../Assets/Home/girl.png";
// import { useNavigate } from "react-router-dom";

// const Seller = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 800,
//       easing: "ease-out",
//       once: true,
//     });
//   }, []);
//    const navigate = useNavigate();
//   const categories = [
//     { img: logo, title: "Kitchen Decor" },
//     { img: logo4, title: "Stone Statue" },
//     { img: logo5, title: "Wooden Art" },
//     { img: logo3, title: "Metal Sculptures" },
//     { img: logo2, title: "Handicraft" },
//     { img: logo1, title: "Home Decor" },
//   ];

//   return (
//     <div className="bg-white px-4 md:px-10 ">
//       <div
//         className="w-full mx-auto flex flex-col-reverse lg:flex-row items-center justify-between gap-10 rounded-md px-4 bg-[#FBFBFB]"
//         data-aos="fade-up"
//       >
//         {/* Left Section */}
//         <div
//           className="flex-1 text-center lg:text-left space-y-6 p-4"
//           data-aos="fade-right"
//           data-aos-delay="200"
//         >
//           <div>
//             <h1 className="font-philosopher text-3xl md:text-4xl text-gray-900 mb-3">
//               Become a Seller with Bharat Karigari
//             </h1>
//             <p className="text-gray-700 text-lg md:text-xl mx-auto lg:mx-0 font-poppins">
//               Join our artisan community and grow your handmade business online.
//             </p>
//           </div>

//           {/* Categories */}
//           <div
//             className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 justify-items-center"
//             data-aos="zoom-in"
//             data-aos-delay="300"
//           >
//             {categories.map((item, index) => (
//               <div
//                 key={index}
//                 className="flex flex-col items-center text-center"
//                 data-aos="fade-up"
//                 data-aos-delay={index * 100}
//               >
//                 <img
//                   src={item.img}
//                   alt={item.title}
//                   className="w-20 h-20 object-contain"
//                 />
//                 <h4 className="mt-2 text-sm font-semibold text-gray-800">
//                   {item.title}
//                 </h4>
//               </div>
//             ))}
//           </div>

//           {/* Button */}
//           <div data-aos="fade-up" data-aos-delay="600">
//             <button onClick={() => navigate("/seller-registration")} className="bg-[#111111] text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-gray-900 transition">
//               Explore Now
//             </button>
//           </div>
//         </div>

//         {/* Right Section (Image) */}
//         <div
//           className="flex-1 flex justify-center lg:justify-end"
//           data-aos="fade-left"
//           data-aos-delay="200"
//         >
//           <img
//             src={img}
//             alt="Seller"
//             className="w-full max-w-md lg:max-w-lg object-contain drop-shadow-lg"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Seller;
